module.exports = __webpack_public_path__ + "img/浏览记录白.ac11b94b.svg";